import React from 'react';
import styled, { css } from '../../../../styled';
import * as Icons from '../../../icons';
import DateCalendarTitle from './DateCalendarTitle';
import MonthCalendarTitle from './MonthCalendarTitle';
import YearCalendarTitle from './YearCalendarTitle';
const Container = styled.div `
  display: flex;
  height: 3.5rem;
  justify-content: center;
  align-items: center;
`;
const Title = styled.div `
  flex: 1;
  text-align: center;

  > span {
    font-weight: 600; // override Subheading font type
    color: ${({ theme }) => theme.colors.INK_800};
  }

  ${props => props.clickable &&
    css `
      > span {
        cursor: pointer;

        :hover {
          color: ${({ theme }) => theme.colors.PRIMARY_500};
        }

        :active {
          color: ${({ theme }) => theme.colors.PRIMARY_700};
        }
      }
    `};
`;
const PageButton = styled.div `
  padding: 0.125rem;
  cursor: pointer;

  > svg {
    vertical-align: middle;
    fill: ${({ theme }) => theme.colors.INK_600};
  }

  :hover {
    > svg {
      fill: ${({ theme }) => theme.colors.PRIMARY_500};
    }
  }

  :active {
    > svg {
      fill: ${({ theme }) => theme.colors.PRIMARY_700};
    }
  }
`;
const CalendarHeader = ({ lang, mode, target, onPrevPage, onNextPage, onChangeMode, hidePrevPage = false, hideNextPage = false, e2ePrevPageButtonId, e2eNextPageButtonId, }) => (React.createElement(Container, null,
    !hidePrevPage && (React.createElement(PageButton, { "data-e2e-id": e2ePrevPageButtonId, onClick: onPrevPage },
        React.createElement(Icons.Outline.Chevron, { position: "LEFT", size: "MEDIUM" }))),
    React.createElement(Title, { clickable: mode !== 'YEAR' },
        mode === 'DATE' && (React.createElement(DateCalendarTitle, { lang: lang, target: target, onChangeMode: onChangeMode })),
        mode === 'MONTH' && (React.createElement(MonthCalendarTitle, { lang: lang, target: target, onChangeMode: onChangeMode })),
        mode === 'YEAR' && React.createElement(YearCalendarTitle, { lang: lang, target: target })),
    !hideNextPage && (React.createElement(PageButton, { "data-e2e-id": e2eNextPageButtonId, onClick: onNextPage },
        React.createElement(Icons.Outline.Chevron, { position: "RIGHT", size: "MEDIUM" })))));
export default CalendarHeader;
//# sourceMappingURL=CalendarHeader.js.map